const translation = {
  Product: "Produit",
  "Header.productNav": "Produit LUKKEY",
  Feature: "Caractéristique",
  "About Us": "À propos de nous",
  FAQ: "FAQ",
  "Privacy Policy": "Politique de confidentialité",
  "Help Center": "Centre d'aide",
  "Header.infoMenu": "Plus",
  "Header.appNow": "Obtenir l’app",
  "Header.appModal.title": "Utilisez l’app LUKKEY maintenant",
  "Header.appModal.subtitle": "Choisissez votre plateforme pour obtenir l’application mobile officielle LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Installez l’app officielle sur iPhone.",
  "Header.appModal.iosButton": "Ouvrir",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Obtenez l’application Android officielle sur Google Play.",
  "Header.appModal.googlePlayButton": "Ouvrir",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Téléchargez directement le dernier APK officiel.",
  "Header.appModal.androidButton": "Télécharger",
  "Header.appModal.note": "Téléchargements mobiles officiels uniquement. Utilisez les liens ci-dessus pour obtenir la dernière version.",
  "Academy": "Académie",
  "Legal": "Mentions légales",
  "AboutUs.title": "À propos de LUKKEY",
  "AboutUs.lede": "LUKKEY est une marque suisse de portefeuilles matériels dédiée à établir le plus haut niveau de sécurité pour la propriété d'actifs numériques.",
  "AboutUs.vision.closing": "Vos clés. Vos actifs. Votre avenir.",
  "AboutUs.quote": "LUKKEY construit la couche de sécurité entre les personnes et les actifs numériques.",
  "AboutUs.block1": "LUKKEY est basé en Suisse. La marque se concentre sur des portefeuilles matériels conçus pour une auto-garde sécurisée.",
  "AboutUs.block2": "Ses produits combinent des éléments sécurisés, une protection anti-effraction et une architecture entièrement hors ligne. L'objectif est de conserver les clés privées dans un environnement isolé.",
  "AboutUs.block3": "Le système est conçu sans Wi‑Fi, USB ni dépendance réseau directe. L'accès par empreinte, les outils de sauvegarde NFC et la large prise en charge des actifs le rendent pratique au quotidien.",
  "AboutUs.block5": "LUKKEY adopte une approche ouverte et auditable pour son firmware et ses logiciels essentiels. Les promesses de sécurité doivent pouvoir être examinées et vérifiées.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Demande d’assistance",
  "WarrantySupport.intro": "Veuillez remplir les informations ci-dessous pour soumettre votre demande d’assistance.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Résumé du problème",
  "WarrantySupport.form.issueTitle.placeholder": "Saisissez un bref résumé",
  "WarrantySupport.form.warrantyType.label": "Type de demande",
  "WarrantySupport.form.warrantyType.placeholder": "Sélectionnez le type de demande",
  "WarrantySupport.form.warrantyType.product": "Problème de l’appareil",
  "WarrantySupport.form.warrantyType.service": "Problème d’app/compte",
  "WarrantySupport.form.warrantyType.replacement": "Autre",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Décrivez le problème ou la demande en détail",
  "WarrantySupport.form.submit": "Envoyer la demande d’assistance",
  "WarrantySupport.alert.success": "Votre demande d’assistance a été envoyée !",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Centre d'aide",
  "HelpCenter.intro":
    "Bienvenue dans le Centre d'aide LUKKEY ! Si vous débutez en cryptomonnaie ou avez besoin d'aide avec votre cold wallet, vous êtes au bon endroit. Notre solution de cold wallet offre la manière la plus sûre de stocker et gérer vos actifs numériques. Vous trouverez ci-dessous des réponses aux questions les plus fréquentes et des conseils de dépannage.",
  "HelpCenter.section4.title": "Besoin d'une aide supplémentaire ?",
  "HelpCenter.section4.intro":
    "Gagnez du temps en démarrant votre demande d’assistance en ligne, et nous vous mettrons en relation avec un spécialiste. Pour votre sécurité, l’assistance officielle ne demandera jamais votre phrase de récupération ni votre clé privée :",
  "HelpCenter.contact.hint": "Utilisez le bouton pour envoyer une demande d’assistance, nous vous répondrons par e‑mail.",
  "HelpCenter.cta.warranty": "Envoyer une demande d’assistance",
  brandName: "LUKKEY",
  tagline: "Gérez votre crypto-monnaie comme jamais auparavant",
  description:
    "Commencez votre voyage vers la liberté financière avec notre application. Sécurisez vos actifs avec notre technologie de portefeuille froid avancée, et gérez vos finances plus intelligemment et plus efficacement. Votre bien-être financier est notre priorité.",
  "home.seoTitle": "LUKKEY | Portefeuille matériel suisse pour une auto-garde sécurisée",
  "home.seoDescription": "LUKKEY est une marque suisse de portefeuilles matériels axée sur la sécurité des cold wallets, la protection hors ligne des clés privées, l’accès par empreinte et la sauvegarde NFC pour une auto-garde sécurisée.",
  learnMore: "En savoir plus",
  "Lock Your Crypto, Securely":
    "Verrouillez votre crypto-monnaie, en toute sécurité",
  Testimonials: "Témoignages",
  Testimonial1:
    "J'utilise ce portefeuille froid depuis des mois maintenant, et je suis impressionné par sa fiabilité et ses fonctionnalités de sécurité. Hautement recommandé !",
  Testimonial2:
    "Ce portefeuille froid a dépassé mes attentes ! Son interface conviviale et sa sécurité de premier ordre en font un incontournable pour toute personne sérieuse dans le domaine de la crypto.",
  Testimonial3:
    "J'ai essayé plusieurs portefeuilles froids auparavant, mais celui-ci se distingue. Son design élégant et ses fonctionnalités avancées facilitent la gestion de mes actifs crypto.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Passionné de cryptomonnaies",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Avocate de la sécurité des crypto-monnaies",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Analyste financier",
  "Touchscreen Interface": "Interface tactile",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Découvrez une gestion facile des crypto-monnaies avec notre interface tactile intuitive, conçue pour une navigation rapide et simple dans vos actifs numériques, permettant des transactions rapides et une gestion sécurisée à portée de main.",
  "Bluetooth Connectivity": "Connectivité Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Synchronisation sans fil avec vos appareils pour des mises à jour en temps réel.",
  "Airtag Tracking": "Suivi Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Suivez facilement votre portefeuille avec l'Airtag intégré.",
  "Secure Chip Technology": "Technologie de puce sécurisée",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Équipé d'une puce de sécurité avancée, garantissant une protection robuste pour vos précieux actifs numériques contre les accès non autorisés et les cybermenaces.",
  "Cross-Platform Support": "Prise en charge multiplateforme",
  "Works with various platforms for easy accessibility.":
    "Compatible avec plusieurs plateformes pour un accès facile.",
  AboutUsDescription1:
    "Chez LUKKEY, nous nous consacrons à fournir des solutions de haute qualité pour la gestion sécurisée de vos actifs cryptographiques.",
  AboutUsDescription2:
    "Notre siège est à Zug, en Suisse. Avec une équipe de professionnels expérimentés, nous nous efforçons d'innover et de nous adapter au paysage en constante évolution du marché des monnaies numériques.",
  BlockchainNetworksSupported: "Réseaux Blockchain supportés",
  CryptocurrenciesSupported: "Prise en charge de plus de 6 000 cryptomonnaies",
  Years: "Années",
  ExpertiseInSecurity: "d'expertise en sécurité",
  FrequentlyAskedQuestions: "Questions fréquemment posées",
  WhatIsColdWallet: "Qu'est-ce qu'un Cold Wallet ?",
  ColdWalletDescription:
    "Un cold wallet est un type de portefeuille de cryptomonnaie qui stocke vos actifs numériques hors ligne, les rendant moins vulnérables aux piratages et autres menaces en ligne. Contrairement aux hot wallets, qui sont connectés à Internet et pratiques pour les transactions fréquentes, les cold wallets sont mieux adaptés au stockage à long terme car ils offrent une sécurité renforcée.",
  HowToSetUpColdWallet: "Comment configurer votre Cold Wallet ?",
  ColdWalletSetupDescription:
    "Configurer votre cold wallet implique généralement d'initialiser l'appareil sur une machine sécurisée et hors ligne. Vous devrez générer et stocker en toute sécurité une phrase de récupération, essentielle pour accéder à vos actifs en cas de perte ou de défaillance de l'appareil. Des instructions détaillées sont fournies lors de votre achat, assurant une installation fluide.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Quelles cryptomonnaies sont compatibles avec vos cold wallets ?",
  CryptocurrenciesCompatibilityDescription:
    "Nos cold wallets prennent en charge une large gamme de cryptomonnaies, y compris les principales comme Bitcoin, Ethereum et Litecoin, ainsi que diverses altcoins. Pour une liste complète des cryptomonnaies prises en charge, veuillez consulter notre site Web ou vous référer à la documentation du produit.",
  HowToSecureColdWallet: "Comment garantir la sécurité de votre Cold Wallet ?",
  ColdWalletSecurityDescription:
    "Pour sécuriser votre cold wallet, conservez toujours la phrase de récupération dans un endroit sûr et privé, ne la partagez jamais avec quiconque, et envisagez d'utiliser des mesures de sécurité supplémentaires telles que des verrous biométriques ou des enceintes sécurisées. Mettre régulièrement à jour le firmware du portefeuille depuis le site officiel aide également à protéger contre les vulnérabilités.",
  ColdWalletNotWorking:
    "Que faire si mon Cold Wallet ne fonctionne pas ou si je rencontre une erreur ?",
  ColdWalletErrorDescription:
    "Si vous rencontrez des problèmes avec votre cold wallet, consultez la section de dépannage de notre guide utilisateur. Pour des problèmes plus spécifiques, contactez notre équipe d'assistance via notre site Web. Assurez-vous d'avoir les informations sur votre appareil à portée de main pour accélérer le processus d'assistance.",
  Community: "Comunidad",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Rejoignez notre communauté sur votre plateforme préférée pour rester à jour, poser des questions et vous connecter avec d'autres utilisateurs.",
  "Subscribe.title": "Recevez les mises à jour du produit",
  "Subscribe.subtitle":
    "Nous suivons les tendances crypto pour vous. Recevez les mises à jour produit, des analyses de marché et des avantages exclusifs — directement dans votre boîte de réception.",
  "Subscribe.placeholder": "Entrez votre e-mail",
  "Subscribe.button": "S’abonner aux mises à jour du produit",
  "Subscribe.input.aria": "Champ de saisie de l’adresse e-mail",
  "Subscribe.success":
    "Merci pour votre abonnement ! Veuillez vérifier votre e-mail de confirmation.",
  "Subscribe.error": "Échec de l’abonnement. Veuillez réessayer plus tard.",
  "Subscribe.invalid": "Veuillez entrer une adresse e-mail valide.",
  "Subscribe.privacy":
    "Votre adresse e-mail sera utilisée uniquement pour l’envoi de notre newsletter et de nos mises à jour. Vous pouvez vous désabonner à tout moment via le lien inclus dans la newsletter.",
  "Subscribe.learnMore":
    "En savoir plus sur la gestion de vos données et vos droits.",
  "Subscribe.popupCompact.title": "Restez informé",
  "Subscribe.popupCompact.subtitle":
    "Mises à jour produit et informations de sécurité. Aucun spam.",
  "Subscribe.popupCompact.button": "S’abonner",
  "Subscribe.popupCompact.privacy":
    "E-mail uniquement. Désabonnement à tout moment.",
  "SubscribeConfirmed.alt.success": "Abonnement confirmé",
  "SubscribeConfirmed.alt.failed": "Échec de l’abonnement",
  "SubscribeConfirmed.title.success": "Abonnement confirmé",
  "SubscribeConfirmed.title.failed": "Échec de l’abonnement",
  "SubscribeConfirmed.message.success":
    "Merci d’avoir confirmé votre e-mail. Votre abonnement est maintenant actif. Un e-mail de bienvenue a été envoyé à votre boîte de réception.",
  "SubscribeConfirmed.message.failed":
    "Le lien de confirmation est invalide ou a expiré. Veuillez revenir à l’accueil et essayer de vous abonner à nouveau.",
  "SubscribeConfirmed.cta.backHome": "Retour à l’accueil",
  "SubscribeConfirmed.note.unsubscribe":
    "Vous pouvez vous désabonner à tout moment via le lien présent dans nos e-mails.",
  // ===== MarketView i18n =====
  "MarketView.title": "Tableau de bord du marché",
  "MarketView.loading": "Chargement...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Cet onglet n'a pas pu être rendu",
  "MarketView.unknownError": "Erreur inconnue",

  // ===== Common i18n =====
  "Common.refresh": "Actualiser",
  "Common.toggleSeriesVisibility": "Basculer cette série",
  "Common.error": "Erreur",
  "Common.dataUpdateTime": "Heure de mise à jour des données",
  "Common.loading": "Chargement...",
  "Common.noDataSource": "Aucune donnée (source non fournie)",

  // ===== Common ranges =====
  "Common.to": "à",
  "Common.clear": "Effacer",
  "Common.range.thisMonth": "Ce mois-ci",
  "Common.range.lastMonth": "Le mois dernier",
  "Common.range.last2": "Les 2 derniers mois",
  "Common.range.last3": "Les 3 derniers mois",
  "Common.range.last6": "Les 6 derniers mois",
  "Common.range.thisYear": "Cette année",
  "Common.range.all": "Tous",
  "Common.range.custom": "Personnalisé",
  "Common.showFilters": "Afficher les filtres",
  "Common.hideFilters": "Masquer les filtres",
  "Common.search": "Rechercher",
  "Common.priority": "Priorité",
  "Common.owner": "Responsable",
  "Common.collaborator": "Collaborateur",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Télécharger backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Télécharger youtube_stats.json",
  "YouTubeTab.loading": "Chargement des métriques YouTube...",
  "YouTubeTab.errorHint":
    "Si la clé API n’est pas configurée, définissez YOUTUBE_API_KEY ou GOOGLE_API_KEY dans backend/.env et redémarrez le backend.",
  "YouTubeTab.header.totalViews": "Vues totales (multi-chaînes, unité : 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Abonnés totaux (multi-chaînes, unité : 10k)",
  "YouTubeTab.dist.views": "Répartition des vues (10k)",
  "YouTubeTab.dist.subscribers": "Répartition des abonnés (10k)",
  "YouTubeTab.card.location": "Lieu:",
  "YouTubeTab.card.registeredAt": "Inscrit le:",
  "YouTubeTab.card.currentSubscribers": "Abonnés actuels",
  "YouTubeTab.card.currentVideos": "Nombre de vidéos actuel",
  "YouTubeTab.card.currentTotalViews": "Vues totales actuelles",
  "YouTubeTab.card.currentTotalComments": "Commentaires totaux actuels",
  "YouTubeTab.chart.totalSubscribers": "Abonnés totaux",
  "YouTubeTab.chart.totalViews": "Vues totales",
  "YouTubeTab.chart.totalComments": "Commentaires totaux",
  "YouTubeTab.chart.totalVideos": "Vidéos totales",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Télécharger backend data/x_stats.json",
  "XTab.downloadJson": "Télécharger x_stats.json",
  "XTab.loading": "Chargement des métriques X...",
  "XTab.errorHint":
    "Si le jeton n’est pas configuré, définissez X_BEARER_TOKEN ou TWITTER_BEARER_TOKEN dans backend/.env et redémarrez le backend.",
  "XTab.header.totalFollowers": "Abonnés totaux (multi-chaînes, unité : 10k)",
  "XTab.header.totalEngagement":
    "Engagement total (5 derniers posts : Likes + Retweets + Réponses + Citations, unité : 10k)",
  "XTab.dist.followers": "Répartition des abonnés (10k)",
  "XTab.dist.engagement":
    "Répartition de l’engagement (5 derniers posts : Likes + Retweets + Réponses + Citations, unité : 10k)",
  "XTab.card.currentFollowers": "Abonnés actuels",
  "XTab.card.currentFollowing": "Abonnements actuels",
  "XTab.card.currentTweets": "Nombre de tweets actuel",
  "XTab.card.recentLikes": "Likes récents (5 derniers posts)",
  "XTab.card.recentRetweets": "Retweets récents (5 derniers posts)",
  "XTab.card.recentReplies": "Réponses récentes (5 derniers posts)",
  "XTab.card.recentQuotes": "Vues récentes (niveau contenu, 5 derniers posts)",
  "XTab.card.listed": "Nombre de listes (niveau canal)",
  "XTab.smallChart.followers": "Abonnés",
  "XTab.smallChart.tweets": "Tweets",
  "XTab.smallChart.likes": "Likes récents",
  "XTab.smallChart.retweets": "Retweets récents",
  "XTab.smallChart.replies": "Réponses récentes",
  "XTab.smallChart.quotes": "Vues récentes (niveau contenu)",
  "XTab.smallChart.following": "Abonnements",
  "XTab.smallChart.listed": "Listé",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Filtrer par mois de création:",
  "Analytics.dashboardTitle": "Tableau de santé du projet",
  "Analytics.metric.completionRate": "Taux d'achèvement",
  "Analytics.metric.teamVelocity": "Vitesse de l'équipe",
  "Analytics.metric.blockerRatio": "Proportion de blocages",
  "Analytics.metric.workloadBalance": "Équilibre de la charge de travail",
  "Analytics.charts.statusDistribution": "Répartition des statuts",
  "Analytics.charts.statusByMonthPercent": "Statuts par mois (pourcentage)",
  "Analytics.charts.priorityDistribution": "Répartition des priorités",
  "Analytics.charts.priorityByMonthPercent": "Priorité par mois (pourcentage)",
  "Analytics.charts.functionTypeDistribution":
    "Répartition des types de fonction",
  "Analytics.charts.functionTypeByMonthPercent":
    "Type de fonction par mois (pourcentage)",
  "Analytics.blocker.ownerPie":
    "Problèmes bloqués · Répartition des responsables (beignet)",
  "Analytics.blocker.ownerByMonth":
    "Problèmes bloqués · Responsables par mois (pourcentage)",
  "Analytics.bug.ownerPie":
    "Problèmes de bug · Répartition des responsables (beignet)",
  "Analytics.bug.ownerByMonth":
    "Problèmes de bug · Responsables par mois (pourcentage)",
  "Analytics.ownerWorkloadDistribution":
    "Répartition de la charge de travail de l'équipe",
  "Analytics.mode.priority": "Répartition des priorités",
  "Analytics.mode.status": "Répartition des statuts",
  "Analytics.mode.type": "Répartition des types",
  "Analytics.blocker.attentionNeeded":
    "Problèmes nécessitant une attention immédiate",
  "Analytics.common.status": "Statut",
  "Analytics.common.owner": "Responsable",
  "Analytics.insights.sectionTitle": "Informations et recommandations",
  "Analytics.insights.efficiency.title":
    "Suggestions d'amélioration de l'efficacité",
  "Analytics.insights.efficiency.completionRate":
    "• Le taux d'achèvement actuel est de {{rate}}%, surveillez les blocages",
  "Analytics.insights.efficiency.avgVelocity":
    "• La vitesse moyenne de l'équipe est de {{velocity}} tâches/personne",
  "Analytics.insights.efficiency.workloadBalance":
    "• L'équilibre de la charge est de {{balance}}%",
  "Analytics.insights.risk.title": "Alertes de risque",
  "Analytics.insights.risk.blockerRatio": "• Proportion de blocages {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Proportion de problèmes P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Traitez d'abord les problèmes prioritaires",

  // ===== Kanban i18n =====
  "Kanban.title": "Vue Kanban",
  "Kanban.totalIssues": "Total {{count}} problèmes",
  "Kanban.searchPlaceholder":
    "Rechercher un titre, numéro d'issue, responsable ou collaborateurs...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "En cours",
  "Kanban.status.blocked": "Bloqué / En attente de confirmation",
  "Kanban.status.reviewTest": "Revue / Test",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Liste des problèmes",
  "List.totalIssues": "Total {{count}} problèmes",
  "List.viewDetails": "Voir les détails",
  "List.openInNewWindow": "Ouvrir dans une nouvelle fenêtre",
  "List.empty.title": "Aucun problème",
  "List.empty.subtitle":
    "Créez le premier problème pour démarrer votre flux de travail",

  // ===== Assets Register i18n =====
  "Assets.title": "Registre des actifs",
  "Assets.totalSets": "Nombre total",
  "Assets.table.employee": "Employé",
  "Assets.table.setCount": "Ensembles",
  "Assets.table.model": "Modèle",
  "Assets.total": "Total",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Suivi des problèmes de projet",
  "LukkeyIssues.goToDemo": "Aller à la page de démonstration",
  "LukkeyIssues.githubProject": "Projet GitHub ↗",
  "LukkeyIssues.githubManageIssues":
    "Gérer les issues directement sur GitHub ↗",
  "LukkeyIssues.financeModel": "Modèle financier",
  "LukkeyIssues.productCoreIssues": "Problèmes du cœur du produit",
  "LukkeyIssues.stats.totalIssues": "📊 Nombre total de problèmes",
  "LukkeyIssues.stats.completed": "✅ Terminés",
  "LukkeyIssues.stats.inProgress": "🔄 En cours",
  "LukkeyIssues.stats.pending": "⏳ En attente",
  "LukkeyIssues.stats.blocked": "🚫 Bloqués",
  "LukkeyIssues.stats.docs": "📚 Docs",
  "LukkeyIssues.tabs.kanban": "Vue Kanban",
  "LukkeyIssues.tabs.analytics": "Analytique",
  "LukkeyIssues.tabs.market": "Tableau de bord du marché",
  "LukkeyIssues.tabs.assets": "Registre des actifs",
  "LukkeyIssues.shareToChatGPT": "Ouvrir LUKKEY.json avec ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Politique de confidentialité LUKKEY",
  "PrivacyPolicy.intro.p1":
    "Chez LUKKEY, nous pensons que la forme de confidentialité la plus sûre est celle qui reste entièrement entre les mains de l’utilisateur.",
  "PrivacyPolicy.intro.p2":
    "Ainsi, que vous utilisiez le portefeuille matériel (cold wallet) LUKKEY ou l’application mobile LUKKEY (App), nous respectons strictement un principe inébranlable :",
  "PrivacyPolicy.intro.p3_strong":
    "Sauf autorisation explicite de l’utilisateur, nous ne collectons, ne stockons ni ne téléversons aucune information utilisateur.",
  "PrivacyPolicy.intro.p3_tail":
    "Toutes les données liées à l’usage sont stockées uniquement en local sur l’appareil de l’utilisateur et ne sont jamais transmises à LUKKEY ni à aucun serveur.",
  "PrivacyPolicy.intro.p4":
    "La présente Politique de confidentialité explique comment nous appliquons ce principe.",

  "PrivacyPolicy.s1.title": "1. Champ d’application",
  "PrivacyPolicy.s1.appliesTo":
    "La présente Politique de confidentialité s’applique à :",
  "PrivacyPolicy.s1.item.hardware":
    "Le portefeuille matériel (cold wallet) LUKKEY",
  "PrivacyPolicy.s1.item.app": "L’application mobile LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Tous deux suivent le principe unifié « zéro collecte, zéro téléversement, stockage local uniquement ».",

  "PrivacyPolicy.s2.title": "2. Informations que NOUS NE collectons PAS",
  "PrivacyPolicy.s2.desc":
    "Pour protéger votre vie privée, nous nous engageons explicitement à ne pas collecter, téléverser ni stocker d’informations utilisateur, y compris (sans s’y limiter) :",
  "PrivacyPolicy.s2.li.identity":
    "Informations d’identité : nom, numéro de téléphone, adresse e‑mail, adresse postale",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Données sensibles du portefeuille : clés privées, phrases mnémoniques, fichiers keystore, mots de passe du portefeuille",
  "PrivacyPolicy.s2.li.blockchain":
    "Données blockchain : adresses de portefeuille, historique des transactions, informations sur les actifs",
  "PrivacyPolicy.s2.li.behavior":
    "Comportements d’utilisation : journaux de l’application, enregistrements de clics, analyses comportementales",
  "PrivacyPolicy.s2.li.technical":
    "Informations techniques : identifiants d’appareil, géolocalisation, adresse IP",
  "PrivacyPolicy.s2.inShort.title": "En bref :",
  "PrivacyPolicy.s2.inShort.desc":
    "Tout ce que vous voyez sur l’appareil matériel et dans l’App n’existe que sur votre appareil. LUKKEY n’y a pas accès.",

  "PrivacyPolicy.s3.title":
    "3. Conception confidentialité & sécurité du portefeuille matériel",
  "PrivacyPolicy.s3.desc":
    "Le cold wallet LUKKEY fournit un environnement totalement hors ligne et sécurisé. Principales caractéristiques :",
  "PrivacyPolicy.s3.h1.title": "1. Matériel de sécurité de niveau militaire",
  "PrivacyPolicy.s3.h1.l1": "Secure Element certifié EAL6+",
  "PrivacyPolicy.s3.h1.l2":
    "Chiffrement au niveau matériel sur toute la chaîne de communication",
  "PrivacyPolicy.s3.h2.title": "2. Fonctions de sécurité",
  "PrivacyPolicy.s3.h2.l1": "Authentification par empreinte digitale",
  "PrivacyPolicy.s3.h2.l2": "Mode confidentialité",
  "PrivacyPolicy.s3.h2.l3": "Gestion isolée de portefeuilles multiples",
  "PrivacyPolicy.s3.h3.title": "3. Isolation complète",
  "PrivacyPolicy.s3.h3.l1": "Aucune connectivité Internet",
  "PrivacyPolicy.s3.h3.l2": "Aucune connexion par câble de données",
  "PrivacyPolicy.s3.h4.title": "4. Auto‑destruction anti‑effraction",
  "PrivacyPolicy.s3.h4.desc":
    "Si l’appareil est démonté, endommagé ou subit une intrusion anormale, le Secure Element détruit automatiquement les données sensibles afin d’empêcher l’extraction des clés privées.",
  "PrivacyPolicy.s3.h5.title":
    "5. Opérations sensibles exécutées uniquement dans le Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Création de portefeuille",
  "PrivacyPolicy.s3.h5.l2": "Importation de portefeuille",
  "PrivacyPolicy.s3.h5.l3": "Signature de transaction",
  "PrivacyPolicy.s3.h5.note":
    "Tous les processus sensibles s’effectuent à 100 % dans le Secure Element, sans jamais être exposés à une puce ou un stockage non sécurisé.",
  "PrivacyPolicy.s3.h6.title":
    "6. Aucune donnée sensible stockée hors du Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Les zones de stockage non sécurisées de l’appareil ne stockent jamais de clés privées, phrases mnémoniques ni aucune information sensible.",

  "PrivacyPolicy.s4.title":
    "4. Conception confidentialité & sécurité de l’App LUKKEY",
  "PrivacyPolicy.s4.desc":
    "L’App LUKKEY se concentre uniquement sur l’affichage d’informations et les notifications. Elle ne traite aucune donnée sensible du portefeuille.",
  "PrivacyPolicy.s4.n1.title": "1. Ce que l’App NE fait PAS",
  "PrivacyPolicy.s4.n1.l1": "Ne génère pas de portefeuilles blockchain",
  "PrivacyPolicy.s4.n1.l2": "N’importe pas de portefeuilles blockchain",
  "PrivacyPolicy.s4.n1.l3":
    "Ne stocke pas de clés privées ni de phrases mnémoniques",
  "PrivacyPolicy.s4.n1.l4": "Ne téléverse aucune donnée utilisateur",
  "PrivacyPolicy.s4.n1.l5":
    "Ne réalise ni analyses comportementales, ni pistage publicitaire, ni collecte de données",
  "PrivacyPolicy.s4.n2.title": "2. Ce que l’App FAIT",
  "PrivacyPolicy.s4.n2.l1":
    "Affiche des informations publiques autorisées par le matériel",
  "PrivacyPolicy.s4.n2.l2":
    "Fournit un panneau de paramètres de confidentialité expliquant l’objectif de chaque permission",
  "PrivacyPolicy.s4.n2.l3":
    "Donne à l’utilisateur un contrôle total pour activer/désactiver les permissions à tout moment",
  "PrivacyPolicy.s4.n2.l4": "Propose le masquage des informations sensibles",
  "PrivacyPolicy.s4.n2.l5":
    "Désactive la capture d’écran/enregistrement sur certaines vues",
  "PrivacyPolicy.s4.n2.l6":
    "Détecte les adresses blockchain suspectes via une correspondance locale",
  "PrivacyPolicy.s4.n2.l7":
    "Met à jour régulièrement les URL, contrats et adresses dangereux",
  "PrivacyPolicy.s4.n2.l8":
    "Flux de mise à jour à sens unique du serveur → appareil uniquement",
  "PrivacyPolicy.s4.n2.l9":
    "Aucune donnée utilisateur n’est jamais renvoyée lors des mises à jour",
  "PrivacyPolicy.s4.n3.title": "3. Stockage local",
  "PrivacyPolicy.s4.n3.p1":
    "L’App ne stocke localement que des données non privées, telles que les préférences d’interface, la langue et le thème. Ces données :",
  "PrivacyPolicy.s4.n3.l1": "ne sont pas téléversées",
  "PrivacyPolicy.s4.n3.l2": "ne sont pas synchronisées",
  "PrivacyPolicy.s4.n3.l3": "ne sont pas accessibles par LUKKEY",

  "PrivacyPolicy.s5.title": "5. Transmission des données & politique serveur",
  "PrivacyPolicy.s5.l1":
    "Les serveurs LUKKEY ne stockent aucune information utilisateur",
  "PrivacyPolicy.s5.l2":
    "La communication App–serveur se limite aux mises à jour de base de données et de version",
  "PrivacyPolicy.s5.l3":
    "Aucune information utilisateur n’est transmise durant la communication",
  "PrivacyPolicy.s5.l4":
    "Même en cas de compromission serveur, aucune donnée utilisateur ne pourrait être exposée, car nous ne la collectons pas",

  "PrivacyPolicy.s6.title": "6. Transparence open‑source",
  "PrivacyPolicy.s6.l1": "Le code source de l’App LUKKEY est open‑source",
  "PrivacyPolicy.s6.l2":
    "Le firmware embarqué du matériel LUKKEY est open‑source",
  "PrivacyPolicy.s6.l3":
    "Entièrement disponible sur GitHub pour audit par tous",
  "PrivacyPolicy.s6.p": "La transparence fait partie de la sécurité.",

  "PrivacyPolicy.s7.title": "7. Contrôle total par l’utilisateur",
  "PrivacyPolicy.s7.p":
    "Bien que nous ne collections pas d’informations utilisateur, les utilisateurs gardent le contrôle total de leurs appareils :",
  "PrivacyPolicy.s7.l1":
    "Vous pouvez désactiver les permissions de l’App à tout moment",
  "PrivacyPolicy.s7.l2":
    "Vous pouvez désinstaller l’App pour supprimer toutes les données locales de l’application",
  "PrivacyPolicy.s7.l3":
    "Vous pouvez réinitialiser l’appareil matériel pour effacer définitivement clés privées et données de portefeuille",
  "PrivacyPolicy.s7.p2":
    "LUKKEY n’intervient pas et ne peut pas intervenir dans ces actions.",

  "PrivacyPolicy.s8.title": "8. Contactez‑nous",
  "PrivacyPolicy.s8.p":
    "Pour toute question concernant cette Politique de confidentialité, veuillez nous contacter :",
  "PrivacyPolicy.s8.email": "E-mail : info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Adresse : Siège LUKKEY, Baarerstrasse 25, 6300 Zoug, Suisse",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Chargement...",
  "EmailOtp.title":
    "Accès restreint : saisissez votre nom et votre e‑mail pour recevoir un code de connexion",
  "EmailOtp.nameLabel": "Nom",
  "EmailOtp.namePlaceholder": "Saisissez votre nom",
  "EmailOtp.emailLabel": "E‑mail",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Envoyer le code",
  "EmailOtp.resendCode": "Renvoyer le code",
  "EmailOtp.resendWithCountdown": "Renvoyer ({{s}}s)",
  "EmailOtp.codeValidityHint":
    "Le code de vérification est valable environ 10 minutes",
  "EmailOtp.codeLabel": "Code de vérification par e‑mail",
  "EmailOtp.codePlaceholder": "Saisissez le code reçu",
  "EmailOtp.signIn": "Se connecter",
  "EmailOtp.message.codeSent":
    "Code de vérification envoyé, veuillez vérifier votre boîte de réception",
  "EmailOtp.error.nameRequired": "Veuillez saisir votre nom",
  "EmailOtp.error.invalidEmail": "Veuillez saisir une adresse e‑mail valide",
  "EmailOtp.error.sendFailed":
    "Échec de l’envoi du code de vérification. Veuillez réessayer plus tard.",
  "EmailOtp.error.codeRequired": "Veuillez saisir le code de vérification",
  "EmailOtp.error.verificationFailed": "Échec de la vérification",
  // ===== Academy i18n =====
  "Academy.hero.alert":
    "Rappel de sécurité : vérifiez toujours les liens et ne partagez jamais votre phrase de récupération.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Académie",
  "Academy.hero.subtitle":
    "Guides pratiques sur la sécurité crypto, l’auto‑garde et l’utilisation du cold wallet LUKKEY.",
  "Academy.search.placeholder":
    "Rechercher des tutoriels, bonnes pratiques et FAQ…",
  "Academy.search.hint": "[ENTRÉE]",
  "Academy.card.type.article": "ARTICLE",
  "Academy.list.title": "Derniers guides",
  "Academy.list.viewAll": "VOIR TOUT",
  "Academy.list.empty": "Aucun résultat. Essayez un autre mot-clé.",
  "Academy.image.placeholder": "IMAGE",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Retour à l’Académie",
  "AcademyArticle.notFound": "Article introuvable",
  "AcademyArticle.author": "Auteur",
  "AcademyArticle.unscheduled": "Aucune date de publication prévue",
  "home.hero.reserveCtaLabel": "Accès anticipé — 1 $US",
  "home.hero.reserveCtaNote": "Entièrement remboursable. Sans engagement d'achat.",
};

export default translation;
